import _ from "lodash";

// Mutate Node State
export const handleNodeState = (path: any[], value: any, setNodeState: any) => {
  setNodeState((prev: any) => _.set(_.cloneDeep(prev), path.join("."), value));
};
// Move Node
export const onDragEnd = ({
  movingElem,
  handleCloseActionPopup,
  nodes,
  dispatch,
  setNodes,
}: any) => {
  const { source, destination, type } = movingElem;

  if (type === "parent") {
    // Reorder parents
    const parents = nodes.filter((item: any) => item.parentNode === "");
    const reorderedParents = Array.from(parents);
    const [movedParent] = reorderedParents.splice(source.index, 1);
    reorderedParents.splice(destination.index, 0, movedParent);

    // Update the data array with reordered parents
    const newData = [...reorderedParents, ...nodes.filter((item: any) => item.parentNode !== "")];
    dispatch(setNodes(newData));
  } else if (type === "child" || type === "childNested" || type === "childNested2") {
    // Reorder or move children
    const sourceParentId = source.droppableId;
    const destinationParentId = destination.droppableId;

    const children = nodes.filter((item: any) => item.parentNode === sourceParentId);
    const [movedChild]: any = children.splice(source.index, 1);

    if (sourceParentId === destinationParentId) {
      // Reordering within the same parent
      children.splice(destination.index, 0, movedChild);

      const newData = [
        ...nodes.filter((item: any) => item.parentNode !== sourceParentId),
        ...children,
      ];
      dispatch(setNodes(newData));
    } else {
      // Moving to a different parent
      const movedChild = {
        ...nodes.find((item: any) => item.id === movingElem.draggableId), // Create a new object
        parentNode: destinationParentId, // Update the parentNode immutably
      };

      const sourceChildren = nodes.filter(
        (item: any) => item.parentNode === sourceParentId && item.id !== movedChild.id
      );
      const destinationChildren = nodes.filter(
        (item: any) => item.parentNode === destinationParentId
      );

      // Insert the updated child into the destination children
      const updatedDestinationChildren = [...destinationChildren];
      updatedDestinationChildren.splice(destination.index, 0, movedChild);

      // Combine all nodes back together immutably
      const newData = [
        ...nodes.filter(
          (item: any) =>
            item.parentNode !== sourceParentId && item.parentNode !== destinationParentId
        ),
        ...sourceChildren,
        ...updatedDestinationChildren,
      ];

      // Dispatch the new state
      dispatch(setNodes(newData));
    }
  }
  handleCloseActionPopup();
};
